import React from 'react';
import Modal from '../../../shared/components/ui/Modal';

const inr = (n) =>
  `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(n) || 0)}`;

const ExtraChargeBreakdownModal = ({ charge, totals, measurementType, onClose }) => {
  const rateLabel = totals.areaBased
    ? `${inr(charge.price)} per ${measurementType}`
    : `${inr(charge.price)} per unit`;

  return (
    <Modal name={`${charge.name} — total breakdown`} onClose={onClose} width={60}>
      <div className="flex flex-col gap-4">
        <p className="text-sm text-[#64748B]">
          Rate: <span className="font-semibold text-[#1A202C]">{rateLabel}</span>
          {totals.gstPct ? ` · GST ${totals.gstPct.toFixed(2)}%` : ''}
          {' · '}
          {totals.areaBased
            ? 'Rate × super build-up area of each unit'
            : 'Flat amount for each unit'}
        </p>

        <div className="overflow-x-auto rounded-xl border border-[#E2E8F0]">
          <table className="w-full text-left text-sm">
            <thead className="bg-[#F8FAFC] text-[#64748B]">
              <tr>
                <th className="px-3 py-2 font-medium">Accommodation</th>
                <th className="px-3 py-2 font-medium text-right">Units</th>
                {totals.areaBased && (
                  <th className="px-3 py-2 font-medium text-right">Area ({measurementType})</th>
                )}
                <th className="px-3 py-2 font-medium text-right">Per unit</th>
                <th className="px-3 py-2 font-medium text-right">Amount</th>
                <th className="px-3 py-2 font-medium text-right">GST</th>
                <th className="px-3 py-2 font-medium text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {totals.rows.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-3 py-6 text-center text-[#94A3B8]">
                    No accommodations attached to this charge.
                  </td>
                </tr>
              ) : (
                totals.rows.map((r) => (
                  <tr key={r.accId} className="border-t border-[#E2E8F0]">
                    <td className="px-3 py-2">{r.name}</td>
                    <td className="px-3 py-2 text-right">{r.unitCount}</td>
                    {totals.areaBased && (
                      <td className="px-3 py-2 text-right">
                        {r.missingArea ? (
                          <span className="text-[#B91C1C]" title="Area not set on this accommodation">
                            missing
                          </span>
                        ) : (
                          r.area
                        )}
                      </td>
                    )}
                    <td className="px-3 py-2 text-right">{inr(r.perUnit)}</td>
                    <td className="px-3 py-2 text-right">{inr(r.subtotal)}</td>
                    <td className="px-3 py-2 text-right">{inr(r.gst)}</td>
                    <td className="px-3 py-2 text-right font-medium">{inr(r.total)}</td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot className="border-t-2 border-[#E2E8F0] bg-[#F8FAFC] font-semibold">
              <tr>
                <td className="px-3 py-2">Total</td>
                <td className="px-3 py-2 text-right">{totals.unitCount}</td>
                {totals.areaBased && <td />}
                <td />
                <td className="px-3 py-2 text-right">{inr(totals.subtotal)}</td>
                <td className="px-3 py-2 text-right">{inr(totals.gst)}</td>
                <td className="px-3 py-2 text-right text-[#2A565E]">{inr(totals.total)}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {totals.hasMissingArea && (
          <p className="text-xs text-[#B91C1C]">
            Some accommodations have no area set, so they count as ₹0 here.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default ExtraChargeBreakdownModal;
